import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Github, ExternalLink } from "lucide-react";

export default function IOS() {
  const [tab, setTab] = useState("sdk");

  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">iOS</h1>
        </div>
      </section>

      <article className="max-w-5xl mx-auto px-6 lg:px-10 py-14">
        <Link
          to="/development-kits"
          className="inline-flex items-center gap-1 text-sm text-[#29abe2] hover:underline mb-8"
        >
          <ChevronLeft className="w-4 h-4" /> Back to Development Kits
        </Link>

        <div className="border-b border-slate-200 flex gap-1 flex-wrap">
          {[
            { id: "sdk", label: "SDK" },
            { id: "demo", label: "Demo" },
            { id: "docs", label: "Documentation" },
          ].map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`px-6 py-3 text-sm font-semibold uppercase tracking-wide transition-colors ${
                tab === t.id
                  ? "text-[#29abe2] border-b-2 border-[#29abe2] -mb-px"
                  : "text-slate-600 hover:text-slate-800"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="py-10">
          {tab === "sdk" && <SdkTab />}
          {tab === "demo" && <DemoTab />}
          {tab === "docs" && <DocsTab />}
        </div>
      </article>
    </div>
  );
}

function GitHubBadge({ href }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 bg-slate-800 hover:bg-slate-900 text-white text-sm font-semibold px-5 py-2.5 rounded transition-colors"
    >
      <Github className="w-4 h-4" />
      Get source on GitHub
    </a>
  );
}

function AppStoreBadge({ href }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 bg-[#29abe2] hover:bg-[#1f9bd0] text-white text-sm font-semibold px-5 py-2.5 rounded transition-colors"
    >
      <ExternalLink className="w-4 h-4" />
      Download on the App Store
    </a>
  );
}

function SdkTab() {
  return (
    <div className="space-y-10">
      <section>
        <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">TappyBLE SDK</h2>
        <p className="text-slate-700 leading-relaxed text-[16px]">
          An SDK for using TappyBLE NFC reader devices on iOS is now available (TappyUSB devices are currently not
          supported on iOS). In order to use the SDK, your device must run iOS 8.0 or newer.
        </p>
        <p className="text-slate-700 leading-relaxed text-[16px] mt-4">
          For additional details and usage information, please see the SDK repository on GitHub.
        </p>
        <div className="mt-5">
          <GitHubBadge href="https://github.com/TapTrack/TCMPTappy-iOS" />
        </div>

        <div className="mt-10">
          <h3 className="text-lg font-semibold text-slate-800 uppercase tracking-wide mb-2">Apache Cordova</h3>
          <p className="text-slate-700 leading-relaxed">
            If you wish to use a Tappy reader with Cordova/PhoneGap, please refer to our Cordova{" "}
            <a
              href="https://taptrack.com/cordova/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#29abe2] hover:underline"
            >
              section
            </a>{" "}
            for further details.
          </p>
        </div>
      </section>
    </div>
  );
}

function DemoTab() {
  return (
    <div>
      <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Demo Application</h2>
      <p className="text-slate-700 leading-relaxed text-[16px]">
        A simple demo application for the TappyBLE available on the App Store that supports basic Tappy operations.
      </p>
      <div className="mt-5">
        <AppStoreBadge href="https://itunes.apple.com/us/app/tappyble/id1020956842?mt=8" />
      </div>
    </div>
  );
}

function DocsTab() {
  return (
    <div>
      <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">Documentation</h2>
      <a
        href="https://docs.google.com/document/d/e/2PACX-1vTnzSyisbi6jD9mepVJsbgf6JL_qWjiIjGGIthRpULt2C5kkpuchm0nYa0U5NSgFOcpzzYzf6S9mGS6/pub?embedded=true"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-[#29abe2] hover:underline text-lg font-semibold"
      >
        Read the full documentation here.
        <ExternalLink className="w-4 h-4" />
      </a>
    </div>
  );
}
